module.exports = __webpack_public_path__ + "img/fi-rr-angle-small-right.bf948b45.svg";